import { GridColDef } from "@mui/x-data-grid-premium";
import { renderDate } from "../../../formatting/dateFormat";
import { ExpandButton } from "../../../components/datagrid/components/ExpandButton";

export const columns: GridColDef[] = [
  {
    field: "expand",
    headerName: "",
    description: "",
    width: 50,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => {
      if (!params.row.fba_shipments?.shipment_id) return null;
      return <ExpandButton rowId={params.id} />;
    },
  },
  {
    field: "fba_shipments.shipment_id",
    headerName: "Shipment ID",
    description: "Amazon Shipment ID",
    valueGetter: (value, row) => row.fba_shipments?.shipment_id,
  },
  {
    field: "fba_shipments.name",
    headerName: "Shipment Name",
    description: "Shipment Name",
    valueGetter: (value, row) => row.fba_shipments?.name,
  },
  {
    field: "fba_shipments.shipment_confirmation_id",
    headerName: "Confirmation ID",
    description:
      "FBA confirmation ID — legacy shipment identifier used in older inbound workflows",
    valueGetter: (value, row) => row.fba_shipments?.shipment_confirmation_id,
  },
  {
    field: "fba_shipments.status",
    headerName: "Status",
    description: "Current Shipment Status",
    valueGetter: (value, row) => row.fba_shipments?.status,
  },
  {
    field: "fba_inbound_plans.inbound_plan_id",
    headerName: "Plan ID",
    description: "Inbound Plan ID",
    valueGetter: (value, row) => row.fba_inbound_plans?.inbound_plan_id,
  },
  {
    field: "fba_shipments.destination_fulfillment_center_id",
    headerName: "Dest. FC",
    description: "Destination Fulfillment Center",
    valueGetter: (value, row) =>
      row.fba_shipments?.destination_fulfillment_center_id,
  },
  {
    field: "fba_shipments.shipping_mode",
    headerName: "Shipping Mode",
    description: "Shipping Mode",
    valueGetter: (value, row) => row.fba_shipments?.shipping_mode,
  },
  {
    field: "fba_shipments.created_at",
    headerName: "Created",
    type: "dateTime",
    description: "Shipment creation date, parsed from shipment name",
    valueGetter: (value, row) => row.fba_shipments?.created_at,
    valueFormatter: (value) => renderDate(value),
  },
  {
    field: "fba_shipments.updated_at",
    headerName: "Last Updated",
    type: "dateTime",
    description: "Last Updated",
    valueGetter: (value, row) => row.fba_shipments?.updated_at,
    valueFormatter: (value) => renderDate(value),
  },
];
